<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <PopupIntroCModal
        :response="content"
        :preTestScore="preTestScore"
        :isAddQueueShow="true"
        :CheckWidth="CheckWidth"
        :checkAnswer="checkAnswer"
        :point="point"
        :checkText="checkText"
        @funcRoute="funcRoute"
      />
    </template>
  </div>
</template>
<script>
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/scss/_chineseModalCustom.scss';
import {mapGetters} from 'vuex';
import PopupIntroCModal from './components/PopupIntroCModal.vue';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {PopupIntroCModal, LoadingMDL},
  name: 'LKT01',
  data() {
    return {
      point: null,
      code: '',
      lang: '',
      content: {},
      checkAnswer: null,
      CheckWidth: window.innerWidth.toString(),
      preTestScore: null,
      courseSection: '',
      startTime: '',
      courseCode: '',
      result: {},
      checkText: false,
      loading: true,
      navigate: {},
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      isTestOpen: 'template/getTestStatus',
      getTemplatev3: 'v3/getTemplates',
    }),
  },

  watch: {
    isTestOpen: function (val) {
      if (val == false) {
        // this.$router.push('/HP01/1');
      }
    },
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template;
      this.navigate = template.navigate;

      if (!template.enable) {
        const pathFormat = template.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }
      // if (val.codeItem === 'LKT01-80') {
      //   this.checkAnswer = true;
      // }
      // if (val.codeItem === 'LKT01-13') {
      //   //for show text
      //   this.checkAnswer = true;
      // }
      this.checkAnswer = this.$store.state.v3.checkingResult;

      const payload = [
        {
          codeItem: this.$store.state.v3.mainCodeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: null,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: null,
          type: null,
          answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      //
      this.$store.dispatch('v3/saveScoreAndProgress', payload);
      //stamp
      this.$store.commit('v3/stampMainCodeItem', val.codeItem);

      //reset checking Result

      this.$store.commit('v3/v3CheckingResultTrue');
      this.loading = false;
    },

    '$route.params.id'() {
      this.onLoad();
    },
  },

  mounted() {
    this.onLoad();
  },

  created() {},

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.lang = this.$store.state.language.language;
      // this.pageCode = `LKT01-` + this.$route.params.id;

      //get score
      // if (this.pageCode === 'LKT01-77') {
      //   let score =
      //     this.$store.getters['template/getDisplayScore'].totalQuizScore;
      //   this.preTestScore = score;
      // }

      // if (
      //   this.pageCode === 'LKT01-24' ||
      //   this.pageCode == 'LKT01-65' ||
      //   this.pageCode == 'LKT01-66'
      // ) {
      //   this.point = this.$store.getters['necessary/getTmpScore'];
      // }
      if (this.pageCode == 'LKT01-65' || this.pageCode == 'LKT01-66') {
        this.checkText = true;
      }

      //set post
      // if (this.pageCode === 'LKT01-78') {
      //   this.$store.commit('necessary/setMode', {mode: true, type: 'POSTTEST'});
      // }

      // //for result matrix
      // let result = this.$store.getters['template/getCheckAnswerResult'];

      // console.log(result, 'result');
      // // console.log(this.checkAnswer);

      // if (result == undefined || result.userAnswer == undefined) {
      //   console.log('check again');

      //   this.checkAnswer = this.$store.getters['template/getCheckingResult'];
      // } else {
      //   if (result.userAnswer.length == 0) {
      //     console.log('no length');

      //     this.checkAnswer = this.$store.getters['template/getCheckingResult'];
      //   } else {
      //     this.checkAnswer = result.userAnswer[0].status;
      //   }
      // }

      //new check result

      // console.log(this.checkAnswer, 'check answer');

      this.courseCode = this.$store.state.necessary.learningCourse;

      const contentId = `LKT01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },

    funcRoute(val) {
      // let payload = {
      //   code: this.courseCode,
      //   template: this.content._id,
      //   section: this.courseSection,
      //   answering: [],
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // };
      // console.log('payload', payload);
      //userUpdate
      // this.$store.dispatch('template/saveUserTemplateData', payload);
      // this.$router.push(`/display${val}`);
      // if (typeof val === 'string') {
      //   this.nextAction = this.$helpers.setChineseUrl(val);
      // } else {
      //   this.$store.commit('necessary/setCodePage', val[1]);
      //   this.nextAction = '/' + val[0] + '/' + val[1];
      // }
      // const nextAction = this.navigate.next.action;
      // console.log(nextAction);
      // this.$router.push(`/display/${nextAction}`);

      /////

      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      this.$store.dispatch('v3/saveContent', data);
      const path = val.split('-');
      const nextPath = `/v3/${path[0]}/${path[1]}`;

      this.$router.push(nextPath);
    },
  },
};
</script>
<style></style>
